export default "__VITE_ASSET__phxgVeA9__"